module.exports = __webpack_public_path__ + "img/banner_left.ac3e3f2a.png";